import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ description, title, image, children}) {
  const { site, ogImageDefault } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
        ogImageDefault: file(relativePath: { eq: "znajdz-zastepstwo-hero.png" }) {
          childImageSharp {
            gatsbyImageData(layout: FIXED, height: 889, width: 1641)
          }
        }
      }
    `
  )

  const defaultImageSrc = ogImageDefault.childImageSharp.gatsbyImageData.images.fallback.src
  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata.title

  const finalTitle = defaultTitle ? `${title} | ${defaultTitle}` : title
  return (
    <>
      <meta charSet="utf-8" />
      <title>{finalTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="author" content={site.siteMetadata.author}/>
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      {
        image === undefined
          ? <meta
            property="og:image"
            content={constructUrl(
              site.siteMetadata?.siteUrl,
              defaultImageSrc
            )}
          />
          : <meta property="og:image" content={image.url} />
      }
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {
        image === undefined
          ? <meta
            property="twitter:image"
            content={constructUrl(
              site.siteMetadata?.siteUrl,
              defaultImageSrc
            )}
          />
          : <meta property="twitter:image" content={image.url} />
      }
      {children}
    </>
  )
}

function constructUrl(baseUrl, path) {
  if (baseUrl === "" || path === "") return "";
  return `${baseUrl}${path}`;
}

export default Seo
